<template>
  <div class="mob-inject">
    <template v-if="showHome">
      <template v-if="!showAddPannel">
            <!-- 場景選擇 -->
        <scene-select
                :no-bg="false"
                @changeScene="loadScene"
                :sel-scene="selectScene"
        ></scene-select>
        <div class="add-box" v-if="currentPaster && Object.keys(currentPaster).length === 0">
        <div class="add-inject" @click="addPaster" >{{$t('publish.tagAdd')+$t('edit.inject')}}</div>
        </div>
        <div class="follow-old" v-else>
          <!-- <div class="options" v-if="currentInJId">
            <div class="options-btn" @click="editItem">{{$t('actionTitles.edit')}}</div>
            <div class="options-btn" @click="deleteItem">{{$t('actionTitles.delete')}}</div>
          </div> -->
          <div class="base-container">
            <div class="list-container">
              <div class="oild-list">
                <TPItem
                  v-for="(value, k) in currentPaster"
                  :key="k"
                  :itemObj="value"
                  :selectedId="currentInJId"
                  @click.native="onClickItem(value)"
                ></TPItem>
              </div>
            </div>
            <div class="adds" @click="addPaster" v-show="showAddBtn">
                <div>
                    <img src="../../assets/img/mob_add_scene.png"/>
                    <h5>{{$t('edit.injectInfo.addPaster')}}</h5>
                </div>
            </div>
            <!-- <div class="add-new" @click="addPaster">
              <div class="text">{{$t('publish.tagAdd')}}</div>
              <div class="text">{{$t('edit.inject')}}</div>
            </div> -->
          </div>
          <!-- 編輯漫遊 -->
    <edit-options
            v-if="editPasterVisible"
            :options="options"
            @returnBack="closeOptions"
            @onclick="editOptions"
    ></edit-options>
        </div>
      </template>
      <template v-else>
        <Steps :title="$t('edit.injectInfo.selectType')" @onClickNext="onClickNext">
          <template slot="body">
            <TextItem
              style="margin-left: 5px"
              :selected="currentTypeItem.title === item.title"
              :title="item.title"
              v-for="(item, index) in addTitles"
              :key="index"
              @click.native="onClickType(item)"
            ></TextItem>
          </template>
        </Steps>
      </template>
    </template>
    <template v-if="imagePVisible">
      <Imagepaster
        :defaultValue="editTarget"
        @onClickBack="onClickBack"
        @saveDataToStore="saveDataToStore"
        @change="handlePasterChange"
      ></Imagepaster>
    </template>
    <template v-if="textPVisible">
      <Textpaster
        :defaultValue="editTarget"
        @onClickBack="onClickBack"
        @saveDataToStore="saveDataToStore"
        @change="handlePasterChange"
      ></Textpaster>
    </template>
    <template v-if="videoPVisible">
      <Videopaster
        :defaultValue="editTarget"
        @onClickBack="onClickBack"
        @saveDataToStore="saveDataToStore"
        @change="handlePasterChange"
      ></Videopaster>
    </template>
  </div>
</template>

<script>
import TextItem from "../TextItem";
import TPItem from "../TPItem";
import Steps from "../Steps.vue";
import Imagepaster from "./component/ImagePaster";
import Textpaster from "./component/TextPaster";
import Videopaster from "./component/VideoPaster";
import { mapGetters } from "vuex";
import EditOptions from "../EditOptions";
import SceneSelect from "../scenes/SceneSelect";

export default {
  components: { TextItem, TPItem, Steps, Imagepaster, Textpaster, Videopaster ,EditOptions,SceneSelect},
  data() {
    return {
      currentPaster: {},
      currentInJId: "",
      showAddPannel: false,
      showHome: true,
      imagePVisible: false,
      textPVisible: false,
      videoPVisible: false,
      addTitles: [
        { title: this.$t('edit.injectInfo.pasterPic'), type: "pic" },
        { title: this.$t('edit.injectInfo.pasterText'), type: "word" },
        { title: this.$t('edit.injectInfo.pasterVideo'), type: "video" },
      ],
      currentTypeItem: {},
      editTarget: null,
      isAddNew: true,
      editPasterVisible: false,
      selectScene:[],
      options:[
          {title: this.$t('actionTitles.edit'), src: require('../../assets/img/mob_create.png'), type: 'edit'},
          {title: this.$t('actionTitles.delete'), src: require('../../assets/img/mob_delete.png'), type: 'delete'},
        ],
        showAddBtn: true,
    };
  },
  computed: { ...mapGetters(["vrbase", "currentScenesId"]) },
  watch: {
    currentScenesId:{
       handler(newVal){
         this.$set(this.selectScene, 0, newVal);
         this.currentPaster = this.vrbase.scenes[this.currentScenesId].paster;
       }
    },
  },
  created() {
    this.currentPaster = this.vrbase.scenes[this.currentScenesId].paster;
    this.selectScene[0] = this.currentScenesId;
  },
  mounted() {
    this.$bus.$on("clickPaster", (e) => {
      let paster = this.currentPaster[e];
      if (paster) {
        this.onClickItem(paster);
        this.editItem();
      }
    });
  },
  methods: {
    onClickItem(value) {
      this.showAddBtn = false;
      this.editPasterVisible=true;
      this.currentInJId = value.paster_id;
      lookto(value.ath, value.atv);
      this.editTarget = value;
    },
    addPaster() {
      this.isAddNew = true;
      this.showAddPannel = true;
      this.resetEditData();
    },
    onClickType(item) {
      this.currentTypeItem = item;
    },
    onClickNext() {
      if (this.currentTypeItem.type) {
        this.handleChange(this.currentTypeItem.type);
      }
    },
    handleChange(value, isAddNew = true) {
      this.isAddNew = isAddNew;
      console.log(value);
      const typeObj = {
        image: value === "pic",
        text: value === "word",
        video: value === "video",
      };
      this.showHome = value === "home";
      this.imagePVisible = typeObj.image;
      this.textPVisible = typeObj.text;
      this.videoPVisible = typeObj.video;
    },
    onClickBack(paster) {
      if (this.isAddNew) {
        removePaster(paster.paster_id);
      }
      this.handleChange("home");
    },
    saveDataToStore({ key, data }) {
      this.handleChange("home");
      let vrbase = this.vrbase;
      vrbase.scenes[this.currentScenesId].paster[key] = data;
      this.$store.dispatch("setVRBase", vrbase);
      this.showAddPannel = false; //增加數據後顯示增加的 數據
    },
    deleteItem() {
      const selectedItem = this.editTarget;
      let paster = this.vrbase.scenes[this.currentScenesId].paster;
      const _this = this;
      this.$confirm({
        title: _this.$t('edit.editMessage.title'),
        content: _this.$t('edit.editMessage.content'),
        okText: _this.$t('edit.editMessage.okText'),
        okType: "danger",
        cancelText: _this.$t('edit.editMessage.cancelText'),
        onOk() {
          removePaster(selectedItem.paster_id);
          _this.$delete(paster, selectedItem.paster_id);
          _this.$store.dispatch("setVRBase", _this.vrbase);
          _this.resetEditData();
        },
        onCancel() {
          console.log("取消");
        },
      });
    },
    editItem() {
      this.handleChange(this.editTarget.type, false);
    },
    resetEditData() {
      this.currentInJId = "";
      this.editTarget = null;
      this.editPasterVisible=false;
    },
    handlePasterChange(val, oldVal) {
      setPaster(val, oldVal);
    },
    loadScene(id){
      this.$store.dispatch("loadScene", id);
      this.closeOptions();
    },
   //關閉編輯
    closeOptions(){
      this.editPasterVisible = false
      this.currHotId = ''
      this.showAddBtn = true;
    },
    //option的功能
    editOptions(type){
      if(type == 'edit'){
        this.editItem()
      }
      if(type == 'delete'){
        this.deleteItem()
      }
      this.editPasterVisible = false
      this.currentInJId = ''
      this.showAddBtn = true
    },
  },
};
</script>
<style lang="less" scoped>
.mob-inject{
    padding: 0 !important;
}
</style>